export default "__VITE_ASSET__BNH5tcLN__"